const DATE_FMT = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

// For YYYY-MM-DD strings — parses as UTC to avoid timezone-induced date shifts.
export function formatDate(d?: string | null): string {
  if (!d) return '—';
  const [y, m, day] = d.split('-').map(Number);
  if (!y || !m || !day) return d;
  return DATE_FMT.format(new Date(Date.UTC(y, m - 1, day)));
}

// For ISO timestamp strings (created_at, joined_at, last_active, enrolled_at).
export function formatTimestamp(d?: string | null): string {
  if (!d) return '—';
  try {
    return DATE_FMT.format(new Date(d));
  } catch {
    return d;
  }
}
